import { XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Area, AreaChart } from 'recharts'
import { motion } from 'framer-motion'
import { useLanguage } from '../contexts/LanguageContext'

const TrendChart = () => {
  const { t } = useLanguage()
  
  const data = [
    { year: '2019', penetration: 12.3, investment: 15.2 },
    { year: '2020', penetration: 18.7, investment: 22.8 },
    { year: '2021', penetration: 24.9, investment: 35.4 },
    { year: '2022', penetration: 31.2, investment: 48.7 },
    { year: '2023', penetration: 37.2, investment: 67.3 },
  ]

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
      className="bg-[#faf6f1]/80 border border-[#2c1810]/20 p-4 sm:p-6 lg:p-8"
    >
      <div className="mb-4 sm:mb-6">
        <h3 className="font-playfair text-lg sm:text-xl font-bold text-[#2c1810] mb-2">{t('trend.title')}</h3>
        <p className="font-merriweather text-sm sm:text-base text-[#2c1810]/80">{t('trend.subtitle')}</p>
      </div>
      
      <div className="h-64 sm:h-80 mb-4 sm:mb-6">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={data} margin={{ top: 5, right: 20, left: 10, bottom: 5 }}>
            <defs>
              <linearGradient id="colorPenetration" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#2c1810" stopOpacity={0.2}/>
                <stop offset="95%" stopColor="#2c1810" stopOpacity={0.1}/>
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" className="opacity-20" />
            <XAxis 
              dataKey="year" 
              className="font-merriweather text-[#2c1810]"
              tick={{ fontSize: 11 }}
            />
            <YAxis 
              className="font-merriweather text-[#2c1810]"
              tick={{ fontSize: 11 }}
              label={{ 
                value: t('trend.aiPenetration'), 
                angle: -90, 
                position: 'insideLeft',
                style: { textAnchor: 'middle', fontSize: '12px', fontFamily: 'Merriweather' }
              }}
            />
            <Tooltip 
              contentStyle={{
                backgroundColor: '#faf6f1',
                border: '1px solid #2c1810',
                borderRadius: '0px',
                boxShadow: '4px 4px 0px rgba(44, 24, 16, 0.1)',
                fontSize: '14px',
                fontFamily: 'Merriweather'
              }}
              formatter={(value, name) => [
                `${value}%`,
                name === 'penetration' ? t('trend.aiPenetration') : t('home.investment')
              ]}
              labelFormatter={(label) => `${t('trend.year')}: ${label}`}
            />
            <Area
              type="monotone"
              dataKey="penetration"
              stroke="#2c1810"
              strokeWidth={2}
              fillOpacity={1}
              fill="url(#colorPenetration)"
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="text-center p-3 sm:p-4 bg-[#2c1810]/5 border border-[#2c1810]/20">
          <div className="font-playfair text-xl sm:text-2xl font-bold text-[#2c1810]">+24.9%</div>
          <div className="font-merriweather text-xs sm:text-sm text-[#2c1810]/80">{t('trend.fiveYearGrowth')}</div>
        </div>
        <div className="text-center p-3 sm:p-4 bg-[#2c1810]/5 border border-[#2c1810]/20">
          <div className="font-playfair text-xl sm:text-2xl font-bold text-[#2c1810]">2025</div>
          <div className="font-merriweather text-xs sm:text-sm text-[#2c1810]/80">{t('trend.predictedExceed')}</div>
        </div>
      </div>
    </motion.div>
  )
}

export default TrendChart 